// Builds an Error carrying the message returned by the backend, falling back
// to a generic one when the body has none.
export const errorFromResponse = async (response, fallback) => {
  let message;
  try {
    const body = await response.json();
    message = Array.isArray(body?.message)
      ? body.message.join(', ')
      : body?.message || body?.error;
  } catch {
    // Body is not JSON
  }
  return new Error(
    message ||
      fallback ||
      `There was an error processing your request (HTTP ${response.status}).`
  );
};
